import { useMemo } from "react";
import { useLocation } from "react-router-dom-v5-compat";
import { FLIGHTS_SHOP_RETURN_PATH } from "@b2bportal/core-utilities";
import { useI18nContext } from "@hopper-b2b/i18n";
import { TripCategory } from "@overrides/types";

export const useFlightShopTitle = (tripCategory: TripCategory) => {
  const { t } = useI18nContext();

  const location = useLocation();

  return useMemo(() => {
    // Check if we're on the return page for both regular shop and exchange flows
    const isReturnPage =
      location.pathname.includes(FLIGHTS_SHOP_RETURN_PATH) ||
      location.pathname.includes("/shop/return");

    return {
      title: isReturnPage
        ? t("core-flights.flightShopTitle.returnTitle")
        : t("core-flights.flightShopTitle.departureTitle"),
      subtitle:
        tripCategory === TripCategory.ONE_WAY ||
        tripCategory === TripCategory.MULTI_CITY
          ? t("core-flights.flightShopTitle.oneWaySubtitle")
          : t("core-flights.flightShopTitle.roundTripSubtitle"),
    };
  }, [location.pathname, t, tripCategory]);
};
